var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.error)?_c('div',{staticClass:"container text-left",domProps:{"innerHTML":_vm._s(_vm.geneFamilyContent)}}):_c('div',[_c('PageNotFound')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }